import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电视剧分类", to: "/category" },
  { label: "资讯专题", to: "/news" },
  { label: "关于本站", to: "/about" },
];

const friendLinks = [
  { label: "仙剑系列资料馆", to: "/category" },
  { label: "仙侠剧集大全", to: "/category" },
  { label: "剧情解读专栏", to: "/news" },
  { label: "角色访谈合集", to: "/news" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-sword-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                仙剑奇侠传
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              专注仙剑奇侠传及经典仙侠影视作品的内容展示，聚合剧集资料、剧情介绍、角色分析与最新资讯。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="whitespace-nowrap text-primary-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">友情链接</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="whitespace-nowrap text-primary-200 transition-colors hover:text-accent-400"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">内容声明</h4>
            <p className="mt-4 text-sm leading-relaxed text-primary-200">
              本站为影视资料展示与体验演示站点，所有内容均为演示数据，不含任何影视播放资源，亦不代表任何官方立场。
            </p>
            <div className="mt-4 flex items-center gap-3 text-lg text-primary-300">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800">
                <i className="ri-mail-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800">
                <i className="ri-weibo-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 仙剑奇侠传影视站 · 本站内容仅供学习与欣赏，版权归原作品方所有</p>
          <p className="whitespace-nowrap">Made for fans · 演示站点</p>
        </div>
      </div>
    </footer>
  );
}